import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommsMessageModel} from './comms-message-dialog.model';
import {TypesService} from '../services/types.service';
import {ClientService} from '../services/client.service';
import {FormsModule, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {OAuthService} from 'angular-oauth2-oidc';
import {HistoryService} from '../services/history.service';
import {CommunicationsService} from '../services/communications.service';
import * as _ from 'lodash';
import {FormBuilderService} from '../services/form-builder.service';
import {NgFor, NgIf} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {FmcLibraryNotificationService} from '../services/notification.service';

@Component({
  selector: 'fmc-comms-message-dialog',
  templateUrl: './comms-message-dialog.component.html',
  styleUrls: ['./comms-message-dialog.component.scss'],
  standalone: true,
  imports: [
    NgFor,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    NgIf
  ]
})
export class CommsMessageDialogComponent implements OnInit, OnChanges {
  @Input() borrowers: any;
  @Input() appId: number;
  @Input() entityType: string;
  @Input() activeLook: string;
  @Input() public userPartyRoleId: any;
  @Input() public userPartyId: any;
  @Output() public closeDialog = new EventEmitter<any>();

  public sms: any;
  public defaultControl = new CommsMessageModel().commsMessageForm;
  public formGroup: UntypedFormGroup;
  public loginList = [];

  constructor(private oauthService: OAuthService,
              public typesService: TypesService,
              public clientService: ClientService,
              public formBuilderService: FormBuilderService,
              public historyService: HistoryService,
              public communicationService: CommunicationsService,
              public notificationService: FmcLibraryNotificationService) {
    this.formGroup = this.defaultControl;
  }

  ngOnInit() {
    console.log('Borrowers:', this.borrowers);
    this.getBorrowers();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('chnages comms', changes);
    if (changes && changes.borrowers && !changes.borrowers.currentValue) {
      this.loginList = [];
    } else if (changes && changes.borrowers && changes.borrowers.currentValue !== changes.borrowers.previousValue && !changes.borrowers.firstChange) {
      this.loginList = [];
      this.getBorrowers();
    }
  }

  getBorrowers() {
    if (this.borrowers && this.borrowers.length > 0) {
      const getLogins = this.borrowers.map(t => (t.party && t.party.iD) ? this.clientService.getPartyLogins(t.party.iD).toPromise().catch(e => Promise.resolve({login: []})) : null);
      Promise.all(getLogins).then((res) => {
        _.each(res, (partyLogin, idx) => {
          if (partyLogin && partyLogin.login && partyLogin.login.length) {
            this.loginList.push({
              name: this.borrowers[idx].party.name,
              username: partyLogin.login[0].username,
              partyId: this.borrowers[idx].party.iD,
            });

            console.log('fetching loginList', this.loginList);
          }
        });
      });
    }
  }

  submitComms(form) {
    if (this.formGroup.valid) {
      const messages = _.map(form.parties, (party) => {
        const identities = {crumbsPartyId: party.partyId};

        if (this.appId) {
          Object.assign(identities, {vxApplicationId: this.appId});
        }

        const comm = {
          identities,
          title: form.subject,
          body: form.message || '',
          contentType: 'text/plain',
          type: 'inbound',
        };
        return comm;
      });
      const work = _.map(messages, msg => this.clientService.sendMessage(msg).toPromise());

      Promise.all(work).then((res) => {
        this.notificationService.notify('success', 'Message sent', 'Success');
        this.formGroup.reset();
        this.saveOntrackMessageHistory(form);
        this.closeDialog.emit('ontrack message sent');
      }, err => {
        console.log(err);
        this.notificationService.notify('error', 'Message could not be sent', 'Error');
        this.closeDialog.emit('Error sending message');
      });

    } else {
      this.formBuilderService.validateAllFormFields(this.formGroup);
      console.log('form is invalid');
      console.log(this.formGroup);
    }
  }


  saveOntrackMessageHistory(form) {
    const note = {
      __t: 'text-note',
      category: 'general',
      title: form.subject,
      text: form.message
    };

    this.historyService.createHistoryNote(this.entityType, this.appId, note);
  }

  public closeDialogAction() {
    this.closeDialog.emit(true);
  }

}
